import { render, staticRenderFns } from "./TeamDocuments.vue?vue&type=template&id=a0853c90&"
import script from "./TeamDocuments.vue?vue&type=script&lang=js&"
export * from "./TeamDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports